import { request } from '../client';

export const placeOrder = (payload, idempotencyKey) =>
  request('/orders', { method: 'POST', body: payload, idempotencyKey });

export const confirmPayment = (saleId, razorpayPaymentId, razorpaySignature) =>
  request(`/orders/${saleId}/confirm-payment`, {
    method: 'POST',
    body: { razorpayPaymentId, razorpaySignature },
  });

export const getPaymentStatus = (saleId) => request(`/orders/${saleId}/payment-status`);

export const listOrders = (params) => request('/orders', { params });

export const getOrder = (id) => request(`/orders/${id}`);

export const getOrderTracking = (id) => request(`/orders/${id}/tracking`);

export const getDeliveryCode = (id) => request(`/orders/${id}/delivery-code`);
